import React from 'react';
import { midas, variables } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const ButtonGroup = ({ spacing, children, dataCy }) => (React.createElement("div", { style: spacing ? { display: 'flex', gap: variables.layoutGutter } : undefined, className: classNames(midas.buttonGroup, midas.buttonGroupBlock), "data-cy": dataCy }, children));
export default ButtonGroup;
